var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuestFormHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 22,
    viewBox: "0 0 29 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0656 4.66466C25.0821 -3.13166 15.3857 0.353755 14.5 4.25191C13.288 0.124451 3.82469 -2.94821 0.934435 4.66466C-2.28214 13.1489 13.3812 20.7618 14.5 22C15.6188 20.9911 31.2821 13.0113 28.0656 4.66466Z",
    fill: "#FF5A79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestFormHeart);
export default __webpack_public_path__ + "static/media/guestFormHeart.d74a4e3a5d855f92efaf07c4a6ad7ca9.svg";
export { ForwardRef as ReactComponent };